import { useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { workflowKeys } from './workflowKeys'
import { IWorkflow } from 'stores/Workflows/Types'
import { useRootStore } from 'stores/RootStore'

interface Props {
  folderId: string
}

export const useWorkflow = ({ folderId }: Props) => {
  const rootStore = useRootStore()
  return useQuery(
    workflowKeys.detail(folderId),
    async () => {
      const res = await sendToApi<{ workflow: IWorkflow }>(`/folders/${folderId}/workflow`, {
        method: 'GET',
      })

      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }

      rootStore.users.bulkAdd(res.data.workflow.users)
      rootStore.channels.bulkAdd(res.data.workflow.channels)

      return res.data
    },
    {
      enabled: !!folderId,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      retry: false,
    },
  )
}
